import Vue from 'vue'
import App from './App.vue'
import router from './router'
// import store from './store'
import 'lib-flexible'
import 'postcss-px2rem'
import './assets/css/init.css'
import 'vant/lib/index.css';
import './assets/css/components.scss'
import { Toast } from 'vant';
import { server } from './request/interface'

Vue.prototype.$server=server;
Vue.use(Toast)

Vue.config.productionTip = false
router.beforeEach((to, from, next) => {
  /* 路由发生变化修改页面title */
  document.title = "湖南智心心理科教设备有限公司";
  next();
});
new Vue({
  router,
  // store,
  render: h => h(App)
}).$mount('#app')
